import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { AuthServerProvider } from 'app/core/auth/auth-session.service';
import { Logout } from './logout.model';
import { ConfigurazioneGeneraleService } from '../services/configurazione-generale.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  isLoggedIn = false;
  redirectUrl = '';
  constructor(private location: Location, private authServerProvider: AuthServerProvider, private confService: ConfigurazioneGeneraleService) {}

  login(): void {
    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.
    location.href = `${location.origin}${this.location.prepareExternalUrl('oauth2/authorization/oidc')}`;
  }

  logout(urlToGo?: string): void {

    this.authServerProvider.logout().subscribe({
      next: (logout: Logout) => {
        this.deleteCookie('XSRF-TOKEN');
        window.location.href = logout.logoutUrl;
      },
      error:()=>{
        window.location.reload(); //Aggiunta per evitare errori di session
      }
    });
  }

  private deleteCookie(cookieName: string):void {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
